import isSponsor from "@helpers/isSponsor"
import { useAppContext } from "@components/AppContext"
import getFormattedAmountValue from "@helpers/getFormattedAmountValue"


const calculateTargets = project => {
  const { identity } = useAppContext()

  let { targetAmount = 0, nonAccreditedInvestorsMax = 0 } = project
  const shouldOverrideSponsorTargets = isSponsor() && !!project

  if (shouldOverrideSponsorTargets) {
    const { id } = project
    const { links = [] } = identity

    const link = links.find(({ projectId }) => projectId === id)

    if (link) {
      const { brokerTargetAmount } = link
      const { brokerNonAccreditedInvestorsMax } = link

      targetAmount = brokerTargetAmount
      nonAccreditedInvestorsMax = brokerNonAccreditedInvestorsMax
    }
  }

  const formattedTargetAmount = getFormattedAmountValue(targetAmount)

  return { targetAmount: formattedTargetAmount, nonAccreditedInvestorsMax }
}

export default calculateTargets
